/**
* @author lmcarrillo <lmcarrillo@sergas.net>
* @copyright Boqueixon 2023
* @version 20.60.60
* @license licenses.txt
*
* @date 2023-03-19 12:47:50
**/

import { Component, OnInit } from "@angular/core";

import { TranslateService } from "@ngx-translate/core";

import { PopoverController } from "@ionic/angular";
import { Router } from "@angular/router";
import { AlertController } from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { TranslateConfiguration } from "../../class/translate-configuration/translate-configuration";
		

		
@Component({
	selector: "app-popover",
	templateUrl: "./popover.component.html",
	styleUrls: ["./popover.component.scss"],
})
		
		
export class PopoverComponent implements OnInit {
		
	/**
	* PopoverComponent:constructor()
	**/
	constructor(
		public popoverController: PopoverController,
		public router: Router,
		public alertController: AlertController,
		public storage: Storage,
		public translateConfiguration: TranslateConfiguration,
		public translateService: TranslateService
	){
		
		// constructor
		
	}
	
	
		
	/**
	* PopoverComponent:dismissPopover()
	**/
	dismissPopover(){
		this.popoverController.dismiss();
	}
		
		
	/**
	* PopoverComponent:clearStorage()
	**/
	clearStorage(){
		this.dismissPopover();
		this.storage.clear();
		this.router.navigate(["/"]);
	}
		
		
	/**
	* PopoverComponent:switchLanguage()
	**/
	switchLanguage(){
		this.dismissPopover();
		this.languageOption();
		
	}
	
	
	/**
	* PopoverComponent:languageOption()
	**/
	languageOption(){
		let inputs:any = [
			{
				name: `language`,
				type: `radio`,
				label: `English`,
				value: `en-GB`,
			},
			{
				name: `language`,
				type: `radio`,
				label: `Español`,
				value: `es`,
			},
			{
				name: `language`,
				type: `radio`,
				label: `Galego`,
				value: `gl`,
			},
		 ];
		this.storage.get(`locale`).then(data=>{
			let current_language:string = `es`;
			if(data != null){
				current_language = data;
				console.log(`popover`,`current_language`,data);
			}
			let new_inputs:any = [];
			inputs.forEach((item, key, index) => {
				if(item.value == current_language){
					new_inputs.push({name: item.name, type: item.type, label: item.label, value: item.value,checked:true});
				}else{
					new_inputs.push({name: item.name, type: item.type, label: item.label, value: item.value});
				}
			});
			this.showLanguage(new_inputs);
		});
	}
	
	
	/**
	* PopoverComponent:showLanguage(data)
	**/
	async showLanguage(data:any){
		const alert = await this.alertController.create({
			header: this.translateService.instant(`Select Language?`),
			inputs: data,
			buttons: [
				{
					text: this.translateService.instant(`Cancel`),
					role: `cancel`,
					handler: () => {
						//console.log("Language Cancel");
					}
				},
				{
					text: this.translateService.instant(`Ok`),
					handler: (locale) => {
						console.log(`locale`,`set`,locale);
						this.storage.set(`locale`,locale);
						this.translateConfiguration.setLanguage(locale);
						this.router.navigate(["/"]);
					}
				},
			],
		});
		await alert.present();
		
	}
	
	
	/**
	* PopoverComponent:exitApp()
	**/
	async exitApp(){
		this.dismissPopover();
		const alert = await this.alertController.create({
			header: this.translateService.instant(`Do you want to exit App?`),
			buttons: [
				{
					text: this.translateService.instant(`Cancel`),
					role: `cancel`,
					handler: () => {
						//console.log("Exit Cancel");
					}
				},
				{
					text: this.translateService.instant(`Ok`),
					handler: (data) => {
						navigator["app"].exitApp();
					}
				},
			],
		});
		await alert.present();
	}
		
		
	/**
	* PopoverComponent:darkMode(event)
	**/
	isDarkMode:boolean = false;
	darkMode(event){
		let systemDark = window.matchMedia("(prefers-color-scheme: dark)");
		systemDark.addListener(this.colorTest);
		if(event.detail.checked){
			document.body.setAttribute("data-theme", "dark");
		}else{
			document.body.setAttribute("data-theme", "light");
		}
	}
	
	
	/**
	* PopoverComponent:colorTest(systemInitiatedDark)
	**/
	colorTest(systemInitiatedDark){
		if (systemInitiatedDark.matches) {
			document.body.setAttribute("data-theme", "dark");
		}else{
			document.body.setAttribute("data-theme", "light");
		}
	}
	
	
	/**
	* PopoverComponent:ngOnInit()
	**/
	ngOnInit(){
		let getDarkMode = document.body.getAttribute("data-theme");
		if(getDarkMode==`dark`){
			this.isDarkMode = true;
		}else{
			this.isDarkMode = false;
		}
	}

		
		
}
